import { Col, Flex, Spin, Tooltip, Typography } from "antd";
import { CommonTable } from "components";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { shouldShowResetButton } from "utils";
import { getColumns } from "./getColumns";
import { WALLETS_WHITELIST_STATUS } from "interfaces";
import { FilterTabs } from "ui";
import { ReactComponent as InfoIcon } from "images/info-icon.svg";
import { WhitelistActionBtn } from "./WhitelistActionBtn";
import { AddWalletsBtn } from "./AddWalletsBtn";
import { useEffect } from "react";

export const WalletsWhitelistPage = observer(() => {
  const { walletsWhitelist, user, settings } = useStores();

  const { isLPRiskManager } = user.roles;

  const searchPlaceholder = isLPRiskManager ? "Поиск по адресу" : "Поиск по адресу, компании, ИНН, ОГРН, ОГРНИП";
  const tooltipTitle =
    "Белый список ограничивает адреса получателей, которые могут указать трейдеры при создании котировки. Все изменения в настройках действуют только на вновь созданные котировки";

  const currentStatus = walletsWhitelist.queryParams?.status?.[0];

  const handleFilterChange = (status?: WALLETS_WHITELIST_STATUS) => {
    walletsWhitelist.onChangeDataFlow({
      filters: { status: status ? [status] : [] },
    });
  };

  const allowedCount = walletsWhitelist.data.filter((item) => item.status === WALLETS_WHITELIST_STATUS.ALLOWED).length;
  const forbiddenCount = walletsWhitelist.data.filter(
    (item) => item.status === WALLETS_WHITELIST_STATUS.FORBIDDEN
  ).length;

  useEffect(() => {
    if (isLPRiskManager) {
      settings.fetchCompanySettings(user.userInfo?.company_id || "");
    }
  }, []);

  return (
    <Flex vertical gap="large">
      <Flex justify="space-between" align="center">
        <Flex align="center" gap="small">
          <Typography.Title>
            Белый список
            <Tooltip title={tooltipTitle}>
              <InfoIcon style={{ width: 16, height: 16, marginBottom: "10px", marginLeft: 2 }} />
            </Tooltip>
          </Typography.Title>
          {isLPRiskManager && <WhitelistActionBtn />}
        </Flex>
        {isLPRiskManager && <AddWalletsBtn />}
      </Flex>

      <CommonTable
        id="wallets-whitelist-table"
        updateWithInterval
        store={walletsWhitelist}
        columns={getColumns({ whiteList: walletsWhitelist, user })}
        whiteBox
        widgets={{
          search: true,
          date: false,
          searchPlaceholder,
        }}
        customShouldShowResetButton={() => shouldShowResetButton(walletsWhitelist, ["status"])}
        additionalElements={
          <Col id="wallets-whitelist-status-filters">
            <FilterTabs
              options={[
                {
                  value: WALLETS_WHITELIST_STATUS.ALLOWED,
                  label: "Разрешённые",
                  tooltip: "Показать только разрешенные адреса",
                  // count: allowedCount || undefined,
                },
                {
                  value: WALLETS_WHITELIST_STATUS.FORBIDDEN,
                  label: "Запрещённые",
                  tooltip: "Показать только запрещенные адреса",
                  // count: forbiddenCount || undefined,
                },
              ]}
              currentValue={currentStatus}
              onChange={handleFilterChange}
              allOptionLabel="Все"
              allOptionTooltip="Показать все адреса независимо от статуса"
              // allOptionCount={walletsWhitelist.paginationData.totalElements || undefined}
            />
          </Col>
        }
      />
    </Flex>
  );
});
